/**
 * Splash Gate Controller
 * Handles localStorage bypass and entry interaction.
 */
(function() {
  const STORAGE_KEY = 'bf_splash_entered';
  const splash = document.getElementById('splash-gate');
  
  if (!splash) return;
  
  const rememberDays = parseInt(splash.dataset.rememberDays, 10) || 0;
  
  function hasEnteredRecently() {
    if (rememberDays === 0) return false;
    
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return false;
    
    const entryTime = parseInt(stored, 10);
    const now = Date.now();
    const daysSince = (now - entryTime) / (1000 * 60 * 60 * 24);
    
    return daysSince < rememberDays;
  }
  
  function hideSplash() {
    splash.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('splash-active');
    
    // Store entry time
    if (rememberDays > 0) {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }
  }
  
  function showSplash() {
    splash.setAttribute('aria-hidden', 'false');
    document.body.classList.add('splash-active');
  }
  
  function init() {
    // Check URL parameter to force show splash (for testing)
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('show_splash') === 'true') {
      localStorage.removeItem(STORAGE_KEY);
    }
    
    // Skip if already entered recently
    if (hasEnteredRecently()) {
      splash.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('splash-active');
      return;
    }
    
    // Show splash
    splash.setAttribute('aria-hidden', 'false');
    document.body.classList.add('splash-active');
    
    // Bind events
    const enterBtn = splash.querySelector('[data-splash-enter]');
    
    if (enterBtn) {
      enterBtn.addEventListener('click', hideSplash);
    }
    
    // Keyboard: Enter or Escape dismisses
    document.addEventListener('keydown', function handler(e) {
      if (e.key === 'Enter' || e.key === 'Escape') {
        hideSplash();
        document.removeEventListener('keydown', handler);
      }
    });
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
